export default "__VITE_ASSET__035d0e3a__"